import { forwardRef } from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;
type Ref = SVGSVGElement;

const Copy = forwardRef<Ref, Props>((props, ref) => (
    <svg
        width='13'
        height='15'
        viewBox='0 0 13 15'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M9.3679 0.780762H1.72028C1.01606 0.780762 0.445679 1.35115 0.445679 2.05536V10.9776H1.72028V2.05536H9.3679V0.780762ZM11.2798 3.32997H4.26949C3.56527 3.32997 2.99488 3.90035 2.99488 4.60457V13.5268C2.99488 14.231 3.56527 14.8014 4.26949 14.8014H11.2798C11.984 14.8014 12.5544 14.231 12.5544 13.5268V4.60457C12.5544 3.90035 11.984 3.32997 11.2798 3.32997ZM11.2798 13.5268H4.26949V4.60457H11.2798V13.5268Z'
            fill='white'
        />
    </svg>
));

export default Copy;
